import React from "react";
import PropTypes from "prop-types";
import Pagination from "./Pagination";

const TableFooter = ({ data, start, limit, recordsTotal, page, onChange }) => (
  <div className="table-footer-controls d-flex justify-content-between p-3 align-items-center">
    <span>
      {`Showing ${data.length ? start + 1 : start} - ${start + data.length} of ${recordsTotal} entries`}
    </span>
    <Pagination
      activePage={page}
      itemsCountPerPage={limit}
      totalItemsCount={recordsTotal}
      onChange={onChange}
    />
  </div>
);

TableFooter.defaultProps = {
  onChange: () => {},
  recordsTotal: 0
};

TableFooter.propTypes = {
  /**
   * the data being displayed in the table
   */
  data: PropTypes.array.isRequired,
  /**
   * the number index of the first item on this page
   */
  start: PropTypes.number.isRequired,
  /**
   * the amount of items visible in a page
   */
  limit: PropTypes.number.isRequired,
  /**
   * the total amount of records between all pages
   */
  recordsTotal: PropTypes.number,
  /**
   * the page number the user is on
   */
  page: PropTypes.number.isRequired,
  /**
   * callback to run when clicking through pages
   */
  onChange: PropTypes.func
};

export default TableFooter;
